<ras-page [show_heading]="true" *ngIf="location" [headingHtml]="'<h1>Storage units in <b>' + location.name + '</b></h1>'" [mapUrl]="location.map_url" description="Moving house? Garage filled to capacity? Or simply need extra storage for your business goods. Rent-A-Store offers secure and convenient public self storage at our our storage facility in {{location.name}}.">

	<ras-hatfield-competition-banner *ngIf="location.key == 'pretoria-hatfield'"></ras-hatfield-competition-banner>
	<ras-carousel *ngIf="location.key != 'pretoria-hatfield'" img="assets/sitetour/{{location_key}}/img%d.jpg" [numFrames]="location ? location.num_tour_imgs : 0" actionText="Take a quick site tour" (action)="show_site_tour = true"></ras-carousel>

	<ras-top-banners></ras-top-banners>

	<p align="center">More reasons to love Rent-A-Store | <a onclick="document.getElementById('reasons-to-love').scrollIntoView({behavior: 'smooth'})">Click here</a></p>

	<main>
		<ras-unit-loading *ngIf="loading_units_state != 'loaded'" (reload)="load_units()" [failed]="loading_units_failed"></ras-unit-loading>
		<ras-unit-grid-grouped-b *ngIf="loading_units_state == 'loaded'" [units]="units" [location]="location"></ras-unit-grid-grouped-b>
	</main>
	<!-- TODO display error on failutre to load units -->

	<ras-reasons-to-love></ras-reasons-to-love>

	<!-- <ras-video-banner *ngIf="video" [video]="video.code" [preview]="video.preview" [position]="video.position" text="We'll take care of it."></ras-video-banner>
 -->
	<ras-box-banner></ras-box-banner>

	<ras-testimonial></ras-testimonial>

	<ras-nearby-suburbs [location]="location"></ras-nearby-suburbs>

</ras-page>

<ras-site-tour *ngIf="location && show_site_tour" img="/assets/sitetour/{{location_key}}/img%d.jpg" img="/assets/sitetour/{{location_key}}/img%d.jpg" [numFrames]="location.num_tour_imgs" (close)="show_site_tour = false"></ras-site-tour>
